import * as dbAccessor from '@/utils/dbAccessor'
import { cloneDeep } from 'lodash'
export async function updateDClassProduct (
  transaction,
  payload,
  warehouses,
  organizationKey,
  path
) {
  if (payload.isDClassProduct) {
    const productsForWarehouses = await Promise.all(
      warehouses.map(async (warehouse) => {
        const warehouseDoc = dbAccessor.buildStoreQuery([
          'warehouses',
          warehouse.warehouseKey,
          'organizations',
          organizationKey,
          'products',
          payload.upc
        ])
        return transaction.get(warehouseDoc)
      })
    )

    const updateFields = {}
    if (payload.upc) {
      updateFields.upc = payload.upc
    }
    if (payload.asin) {
      updateFields.asin = payload.asin
    }
    if (payload.sku) {
      updateFields.sku = payload.sku
    }
    if (payload.price) {
      updateFields.price = payload.price
    }
    if (payload.name) {
      updateFields.name = payload.name
    }
    if (payload.condition) {
      updateFields.condition = payload.condition
    }
    if (payload.note) {
      updateFields.note = payload.note
    }

    productsForWarehouses.forEach((doc, index) => {
      if (doc.exists) {
        transaction.update(
          doc.ref,
          dbAccessor.addUpdateDocTimestamp(updateFields)
        )
      } else {
        const warehouseKey = warehouses[index].warehouseKey
        const { id, inbound, distribution, quantity, ...rest } = payload
        const data = {
          ...rest,
          path: path,
          warehouseKey: warehouseKey,
          organizationKey: organizationKey
        }
        transaction.set(doc.ref, dbAccessor.addUpdateDocTimestamp(data))
      }
    })
  }
}

export async function transformCombinedProducts (shipment, getProductInfoById) {
  const productIds = new Set()
  const { siteKey } = shipment
  shipment.products.forEach((product) => {
    if (product.isCombined) {
      product.components.forEach((component) => {
        productIds.add(component.id)
      })
    } else {
      productIds.add(product.id)
    }
  })

  const productInfoMap = {}
  await Promise.all(
    Array.from(productIds).map(async (id) => {
      const productInfo = await getProductInfoById(id, siteKey)
      productInfoMap[id] = productInfo
    })
  )

  const originalProducts = cloneDeep(shipment.products)
  const mergedProducts = {}

  for (const product of shipment.products) {
    if (product.isCombined) {
      const childProducts = product.components.map((component) => {
        const productInfo = productInfoMap[component.id]
        productInfo.requiredQty = component.requiredQty
        return productInfo
      })

      childProducts.forEach((child) => {
        const upc = child.upc
        const { requiredQty, ...rest } = child
        if (mergedProducts[upc]) {
          mergedProducts[upc].toShip += product.toShip * requiredQty
        } else {
          mergedProducts[upc] = {
            ...rest,
            toShip: product.toShip * requiredQty
          }
        }
      })
    } else {
      const upc = product.upc
      if (mergedProducts[upc]) {
        mergedProducts[upc].toShip += product.toShip
      } else {
        mergedProducts[upc] = { ...product }
      }
    }
  }

  const transformedProducts = Object.values(mergedProducts)

  return {
    ...shipment,
    originalProducts,
    products: transformedProducts
  }
}

export function generateTenantProductQuery (dbAccessor, clientKey) {
  return async (id, siteKey) => {
    const doc = await dbAccessor
      .buildStoreQuery(['tenants', clientKey, 'inventory', id])
      .get()
    if (!doc.exists) {
      throw Error('missing-product')
    }
    const data = doc.data()
    const distribution = Object.keys(data.distribution).reduce(
      (distribution, key) => {
        const item = data.distribution[key]
        if (item.warehouseSite === siteKey) {
          const { quantity, ...rest } = item
          return {
            ...rest,
            fbmKey: key
          }
        }
        return distribution
      },
      null
    )
    if (!distribution) {
      throw Error('missing-distribution')
    }

    const info = {
      ...distribution,
      id: doc.id,
      name: data.name,
      upc: data.upc,
      price: data.price,
      condition: data.condition,
      sku: data.sku
    }
    return info
  }
}



// WEBPACK FOOTER //
// ./src/store/tenant/tenantHelper.js